//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('dataMiningTable', {
//        templateUrl: 'views/components/views/dataMiningTable/dataMiningTable.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'dataMiningTableComponentService', 'ttGridFactory', 'rememberService', function ($stateParams, stateService, utilityService, dataMiningTableComponentService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let p2StatSourceKeyno = $stateParams.p2_statsource_keyno;
//            let levelNo = $stateParams.level_no;

//            let variableNames = {
//                column_colname: ''
//            };

//            vm.model = {
//                gridReady: false,
//                setting: {},
//                selectListColumnNames: []
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await dataMiningTableComponentService.getSetting({
//                    p2_statsource_keyno: p2StatSourceKeyno,
//                    level_no: levelNo
//                }))[0];
//            }

//            async function loadColumnNames() {
//                vm.model.selectListColumnNames = await dataMiningTableComponentService.listColumnNames({
//                    p2_statsource_keyno: p2StatSourceKeyno,
//                    level_no: levelNo
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: vm.model.setting
//                    };

//                    vm.model.gridReady = true;

//                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                }
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'column_colname':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'column_colname':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.column_colname) !== true) return;

//                        vm.model.setting.column_colname = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.column_colname) !== true) return;

//                        Promise.all([
//                            rememberFunc('column_colname')
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadColumnNames();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
